import { render, staticRenderFns } from "./CardIeaApp.vue?vue&type=template&id=fd331f08"
import script from "./CardIeaApp.vue?vue&type=script&lang=js"
export * from "./CardIeaApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports